import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export const NoDataBanner = ({ message = "No data found" }) => (
  <MDBox
    px={2}
    py={4}
    mt={2}
    display="flex"
    justifyContent="center"
    alignItems="center"
    sx={{ width: "100%" }}
  >
    <MDTypography variant="h6" color="info" fontWeight="medium">
      {message}
    </MDTypography>
  </MDBox>
);

NoDataBanner.propTypes = {
  message: PropTypes.string,
};
